<template>
  <div class="businessData">
    <el-tabs type="card" v-model="modelValue" @tab-click="chooseMoel">
      <el-tab-pane>
        <span slot="label" name="device"><i class="el-icon-bank-card"></i> 设备维度</span>
      </el-tab-pane>
      <el-tab-pane>
        <span slot="label" name="order"><i class="el-icon-tickets"></i> 订单维度</span>
      </el-tab-pane>
      <el-tab-pane>
        <span slot="label" name="store"><i class="el-icon-office-building"></i> 门店维度</span>
      </el-tab-pane>
    </el-tabs>

    <!-- 设备维度 -->
    <div class="device" v-show="modelValue === '0'">
      <el-form ref="form" :model="device" label-position="right">
        <el-form-item><el-input v-model="device.deviceId" clearable placeholder="设备编号" style="width:200px"></el-input></el-form-item>
        <el-form-item>
          <el-select v-model="device.deviceType" clearable placeholder="设备类型" style="width:200px">
            <el-option v-for="item in this.global.device_type" :key="item.code" :label="item.message" :value="item.code" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="device.deployState" clearable placeholder="部署状态" style="width:200px">
            <el-option v-for="item in this.global.device_deploy_state" :key="item.code" :label="item.message" :value="item.code" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="device.onOffState" clearable placeholder="在线离线状态" style="width:200px">
            <el-option v-for="item in this.global.channel_state" :key="item.code" :label="item.message" :value="item.code" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="device.offLineTime" clearable placeholder="离线时长" style="width:200px">
            <el-option v-for="item in this.global.device_offline_time" :key="item.code" :label="item.message" :value="item.code" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item><el-input v-model="device.csName" clearable placeholder="代理名称" style="width:200px"></el-input></el-form-item>
        <el-form-item><el-input v-model="device.csPhone" clearable placeholder="代理电话" style="width:200px"></el-input></el-form-item>
        <el-form-item><el-input v-model="device.bdName" clearable placeholder="bd名称" style="width:200px"></el-input></el-form-item>
      </el-form>
      <el-form class="device" v-show="modelValue === '0'">
        <el-form-item><el-input v-model="device.bdPhone" clearable placeholder="bd电话" style="width:200px"></el-input></el-form-item>
        <el-form-item><el-input v-model="device.storeName" clearable placeholder="门店名称" style="width:200px"></el-input></el-form-item>
        <el-form-item>
          <el-date-picker @change="chooseTime" v-model="time" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width:240px"></el-date-picker>
        </el-form-item>
        <el-form-item>
            <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="queryData()">查询</el-button>
            <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reSet()">重置</el-button>
            <el-button style="background-color:#FF4000" icon="el-icon-bottom" @click="exportData()">导出</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="response.deviceBusinessData"  v-show="modelValue === '0'" style="margin:auto;width:calc(100% - 30px)" height="700" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}">
         <el-table-column prop=".deviceId" label="设备编号" width="200" align="center"></el-table-column>
         <el-table-column prop="deviceState" label="部署状态" width="150" align="center"></el-table-column>
         <el-table-column prop="deviceLineState" label="在离线状态" width="200" align="center"></el-table-column>
         <el-table-column prop="csName" label="代理名称" width="400" align="center"></el-table-column>
         <el-table-column prop="csPhone" label="代理电话" width="200" align="center"></el-table-column>
         <el-table-column prop="bdName" label="bd姓名" width="200" align="center"></el-table-column>
         <el-table-column prop="bdPhone" label="bd电话" width="200" align="center"></el-table-column>
         <el-table-column prop="storeName" label="门店名称" width="200" align="center"></el-table-column>
         <el-table-column prop="storeAddress" label="门店地址" width="500" align="center"></el-table-column>
         <el-table-column prop="deployTime" label="部署时间" width="200" align="center"></el-table-column>
         <el-table-column prop="deployPerson" label="部署人" width="200" align="center"></el-table-column>
         <el-table-column prop="orders" label="订单数量" width="200" align="center"></el-table-column>
         <el-table-column prop="offLineTime" label="离线时间" width="200" align="center"></el-table-column>
         <el-table-column prop="onfLineTimes" label="离线时长" width="200" align="center"></el-table-column>
      </el-table>
     </div>

    <!-- 订单维度 -->
    <div class="order" v-show="modelValue === '1'">
      <el-form ref="form" :model="order">
        <el-form-item><el-input v-model="order.orderId" clearable placeholder="订单编号" style="width:160px"></el-input></el-form-item>
        <el-form-item><el-input v-model="order.csName" clearable placeholder="代理名称" style="width:160px"></el-input></el-form-item>
        <el-form-item><el-input v-model="order.csPhone" clearable placeholder="代理电话" style="width:160px"></el-input></el-form-item>
        <el-form-item><el-input v-model="order.bdName" clearable placeholder="bd名称" style="width:160px"></el-input></el-form-item>
        <el-form-item><el-input v-model="order.bdPhone" clearable placeholder="bd电话" style="width:160px"></el-input></el-form-item>
        <el-form-item><el-input v-model="order.storeName" clearable placeholder="门店名称" style="width:160px"></el-input></el-form-item>
        <el-form-item><el-input v-model="order.bsName" clearable placeholder="商户名称" style="width:160px"></el-input></el-form-item>
        <el-form-item><el-input v-model="order.bsPhone" clearable placeholder="商户电话" style="width:160px"></el-input></el-form-item>
        <el-form-item><el-input v-model="order.usPhone" clearable placeholder="用户手机号" style="width:160px"></el-input></el-form-item>
        <el-form-item>
          <el-select v-model="order.nnOrderFlag" clearable placeholder="订单状态" style="width:160px">
            <el-option v-for="item in this.orderState" :key="item.value" :label="item.name" :value="item.value" ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form ref="form" :model="order">
        <el-form-item>
          <el-select v-model="order.orderSource" clearable placeholder="订单来源" style="width:160px">
            <el-option v-for="item in this.orderSource" :key="item.code" :label="item.message" :value="item.code" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item><el-input v-model="order.powerBankId" clearable placeholder="充电宝编号" style="width:160px"></el-input></el-form-item>
        <el-form-item><el-input v-model="order.powerBoxId" clearable placeholder="设备编号" style="width:160px"></el-input></el-form-item>
        <el-form-item>
          <el-select v-model="order.province" clearable placeholder="省" @change="provinceChoose" style="width:160px">
            <el-option v-for="item in this.province" :key="item.code" :label="item.value" :value="item.code" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="order.city" clearable placeholder="市" @change="cityChoose" style="width:160px">
            <el-option v-for="item in this.city" :key="item.code" :label="item.value" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="order.area" clearable placeholder="区" style="width:160px">
            <el-option v-for="item in this.area" :key="item.code" :label="item.value" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker @change="chooseTime" v-model="time" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width:240px"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="order.rentDuration" clearable = true placeholder="租借时长" style="width:200px">
            <el-option v-for="(item,index) in global.order_search_time" :key="index" :label="item.message" :value="item.code"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
            <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="queryData()">查询</el-button>
            <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reSet()">重置</el-button>
            <el-button style="background-color:#FF4000" icon="el-icon-bottom" @click="exportData()">导出</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="response.orderBusinessData"  v-show="modelValue === '1'" style="margin:auto;width:calc(100% - 30px)" height="700" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.1%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}">
         <el-table-column prop="orderId" label="订单编号" width="250" align="center"></el-table-column>
         <el-table-column prop="orderState" label="订单状态" width="150" align="center"></el-table-column>
         <el-table-column prop="orderSource" label="订单来源" width="200" align="center"></el-table-column>
         <el-table-column prop="rentPowerBoxId" label="租借设备编号" width="200" align="center"></el-table-column>
         <el-table-column prop="returnPowerBoxId" label="归还设备编号" width="200" align="center"></el-table-column>
         <el-table-column prop="powerBankId" label="充电宝编号" width="200" align="center"></el-table-column>
         <el-table-column prop="orderMoney" label="订单金额" width="200" align="center"></el-table-column>
         <el-table-column prop="discountMoney" label="优惠金额" width="200" align="center"></el-table-column>
         <el-table-column prop="refundMoney" label="退款金额" width="200" align="center"></el-table-column>
         <el-table-column prop="realPayMoney" label="实付金额" width="200" align="center"></el-table-column>
         <el-table-column prop="finalMoney" label="最终金额" width="200" align="center"></el-table-column>
         <el-table-column label="租借时间" width="200" align="center">
           <template slot-scope="scope">{{scope.row.rentTime | formatDate}}</template>
         </el-table-column>
         <el-table-column label="归还时间" width="200" align="center">
           <template slot-scope="scope">{{scope.row.returnTime | formatDate}}</template>
         </el-table-column>
         <el-table-column label="支付时间" width="200" align="center">
           <template slot-scope="scope">{{scope.row.payTime | formatDate}}</template>
         </el-table-column>
         <el-table-column prop="csName" label="订单所属代理" width="500" align="center"></el-table-column>
         <el-table-column prop="csPhone" label="代理电话" width="200" align="center"></el-table-column>
         <el-table-column prop="csBaseReward" label="代理分润基数" width="200" align="center"></el-table-column>
         <el-table-column prop="csRewardPercent" label="代理分润比例" width="200" align="center"></el-table-column>
         <el-table-column prop="csReward" label="代理分润金额" width="200" align="center"></el-table-column>
         <el-table-column prop="bsName" label="订单所属商户" width="200" align="center"></el-table-column>
         <el-table-column prop="bsPhone" label="商户电话" width="200" align="center"></el-table-column>
         <el-table-column prop="bsBaseReward" label="商户分润基数" width="200" align="center"></el-table-column>
         <el-table-column prop="bsRewardPercent" label="商户分润比例" width="200" align="center"></el-table-column>
         <el-table-column prop="bsTxPercent" label="商户摊销比例" width="200" align="center"></el-table-column>
         <el-table-column prop="bsReward" label="商户分润金额" width="200" align="center"></el-table-column>
         <el-table-column prop="bdName" label="订单所属bd" width="200" align="center"></el-table-column>
         <el-table-column prop="bdPhone" label="bd电话" width="200" align="center"></el-table-column>
         <el-table-column prop="rentStoreName" label="租借门店" width="200" align="center"></el-table-column>
         <el-table-column prop="rentStoreArea" label="租借门店地区" width="200" align="center"></el-table-column>
         <el-table-column prop="rentStoreAddress" label="租借门店地址" width="500" align="center"></el-table-column>
         <el-table-column prop="returnStoreName" label="归还门店" width="200" align="center"></el-table-column>
         <el-table-column prop="returnStoreArea" label="归还门店门店地区" width="200" align="center"></el-table-column>
         <el-table-column prop="returnStoreAddress" label="归还门店地址" width="500" align="center"></el-table-column>
         <el-table-column prop="usNickName" label="用户昵称" width="200" align="center"></el-table-column>
         <el-table-column prop="usPhone" label="用户电话" width="200" align="center"></el-table-column>
         <el-table-column prop="rentDuration" label="租借时长" width="200" align="center"></el-table-column>
      </el-table>
     </div>

     <!-- 门店维度 -->
    <div class="order" v-show="modelValue === '2'">
      <el-form ref="form" :model="store">
        <el-form-item><el-input v-model="store.csName" clearable placeholder="代理名称" style="width:180px"></el-input></el-form-item>
        <el-form-item><el-input v-model="store.csPhone" clearable placeholder="代理电话" style="width:180px"></el-input></el-form-item>
        <el-form-item><el-input v-model="store.bdName" clearable placeholder="bd名称" style="width:180px"></el-input></el-form-item>
        <el-form-item><el-input v-model="store.bdPhone" clearable placeholder="bd电话" style="width:180px"></el-input></el-form-item>
        <el-form-item><el-input v-model="store.bsName" clearable placeholder="商户名称" style="width:180px"></el-input></el-form-item>
        <el-form-item><el-input v-model="store.bsPhone" clearable placeholder="商户电话" style="width:180px"></el-input></el-form-item>
        <el-form-item><el-input v-model="store.storeCode" clearable placeholder="门店编号" style="width:180px"></el-input></el-form-item>
        <el-form-item><el-input v-model="store.storeName" clearable placeholder="门店名称" style="width:180px"></el-input></el-form-item>
        <el-form-item><el-input v-model="store.concatPerson" clearable placeholder="门店联系人" style="width:180px"></el-input></el-form-item>
      </el-form>
      <el-form class="order" v-show="modelValue === '2'">
        <el-form-item><el-input v-model="store.concatPhone" clearable placeholder="门店联系人" style="width:180px"></el-input></el-form-item>
        <el-form-item>
          <el-select v-model="store.province" clearable placeholder="省" @change="provinceChoose" style="width:180px">
            <el-option v-for="item in this.province" :key="item.code" :label="item.value" :value="item.code" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="store.city" clearable placeholder="市" @change="cityChoose" style="width:180px">
            <el-option v-for="item in this.city" :key="item.code" :label="item.value" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="store.area" clearable placeholder="区" style="width:180px">
            <el-option v-for="item in this.area" :key="item.code" :label="item.value" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
            <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="queryData()">查询</el-button>
            <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reSet()">重置</el-button>
            <el-button style="background-color:#FF4000" icon="el-icon-bottom" @click="exportData()">导出</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="response.storeBusinessData"  v-show="modelValue === '2'"
                style="margin:auto;width:calc(100% - 30px)" height="700" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.2%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}">
         <el-table-column prop="storeCode" label="门店编号" width="200" align="center"></el-table-column>
         <el-table-column prop="storeName" label="门店名称" width="150" align="center"></el-table-column>
         <el-table-column prop="maxPrice" label="封顶价格" width="100" align="center"></el-table-column>
         <el-table-column prop="unitPrice" label="门店单价" width="200" align="center"></el-table-column>
         <el-table-column prop="area" label="门店所在地区" width="200" align="center"></el-table-column>
         <el-table-column prop="address" label="门店地址" width="500" align="center"></el-table-column>
         <el-table-column prop="category" label="门店品类" width="200" align="center"></el-table-column>
         <el-table-column prop="powerBoxId" label="部署设备编号" width="200" align="center"></el-table-column>
         <el-table-column prop="concatPerson" label="门店联系人" width="200" align="center"></el-table-column>
         <el-table-column prop="concatPhone" label="门店联系电话" width="200" align="center"></el-table-column>
         <el-table-column prop="time" label="营业时间" width="200" align="center"></el-table-column>
         <el-table-column prop="chainFlag" label="是否连锁" width="200" align="center"></el-table-column>
         <el-table-column prop="csName" label="代理名称" width="200" align="center"></el-table-column>
         <el-table-column prop="csPhone" label="代理电话" width="500" align="center"></el-table-column>
         <el-table-column prop="bsName" label="商户名称" width="200" align="center"></el-table-column>
         <el-table-column prop="bsPhone" label="商户电话" width="200" align="center"></el-table-column>
         <el-table-column prop="bdName" label="bd名称" width="200" align="center"></el-table-column>
         <el-table-column prop="bdPhone" label="bd电话" width="200" align="center"></el-table-column>
         <el-table-column prop="moneys" label="累计产出" width="200" align="center"></el-table-column>
      </el-table>
     </div>
    <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
  </div>
</template>
<script>
import {deviceBusinessData, exportDeviceBusinessData, orderBusinessData, exportOrderBusinessData,
        storeBusinessData, exportStoreBusinessData} from '../../api/businessdata/businessData.js'
import {GLOBAL_URL} from '../../config/config.js'
import { formatDate } from "../../utils/date";
export default {
  name: 'BusinessData',
  data() {
    return {
      modelValue: 0,
      deviceMore: false,
      time: '',
      device: {
        deviceId: '',
        csName: '',
        csPhone: '',
        bdName: '',
        bdPhone: '',
        storeName: '',
        startTime: '',
        endTime: '',
        deviceType: '',
        onOffState: '',
        deployState: '',
        offLineTime: '',
        current: '',
        size: ''
      },
      order: {
        orderId: '',
        csName: '',
        csPhone: '',
        bdName: '',
        bdPhone: '',
        storeName: '',
        bsName: '',
        bsPhone: '',
        usPhone: '',
        rentDuration:'',
        orderSource: '',
        powerBankId: '',
        powerBoxId: '',
        province: '',
        city: '',
        area: '',
        startTime: '',
        endTime: '',
        nnOrderFlag: '0',
        current: '',
        size: ''
      },
      store: {
        csName: '',
        csPhone: '',
        bdName: '',
        bdPhone: '',
        bsName: '',
        bsPhone: '',
        storeCode: '',
        storeName: '',
        concatPerson: '',
        concatPhone: '',
        province: '',
        city: '',
        area: '',
        current: '',
        size: ''
      },
      orderState: [
        {
          name: "已支付",
          value: "0"
        },
        {
          name: "已购买",
          value: "1"
        },
        {
          name: "待支付",
          value: "2"
        }
      ],
      province: '',
      city: '',
      area: '',
      orderSource: '',
      loading: false,
      showClose: false,
      excelUrl: '',
      showTime: 3000,
      notifyClick: '',
      global: '',
      message: '正在生成Excel文件，准备完成之后，系统会自动下载Excel文件，请勿关闭浏览器',
      query: {current: 1, size: 15},
      response: {deviceBusinessData: [], orderBusinessData: [], storeBusinessData: [], total: 0},
    }
  },
  methods: {

    /**
     * 模块选择触发事件
     */
    chooseMoel(value){
      this.time = '';
      this.store.csName = "";
      this.store.csPhone = "";
      this.store.bdName = "";
      this.store.bdPhone = "";
      this.store.bsName = "";
      this.store.bsPhone = "";
      this.store.storeCode = "";
      this.store.storeName = "";
      this.store.concatPerson = "";
      this.store.concatPhone = "";
      this.store.csNprovinceame = "";
      this.store.city = "";
      this.store.area = "";
      this.device.deviceId = "";
      this.device.csName = "";
      this.device.csPhone = "";
      this.device.bdName = "";
      this.device.bdPhone = "";
      this.device.storeName = "";
      this.device.startTime = "";
      this.device.endTime = "";
      this.device.deviceType = "";
      this.device.onOffState = "";
      this.device.deployState = "";
      this.device.offLineTime = "";
      this.order.orderId = "";
      this.order.csName = "";
      this.order.csPhone = "";
      this.order.bdName = "";
      this.order.bdPhone = "";
      this.order.storeName = "";
      this.order.bsName = "";
      this.order.bsPhone = "";
      this.order.usPhone = "";
      this.order.rentDuration = "";
      this.order.orderSource = "";
      this.order.powerBankId = "";
      this.order.powerBoxId = "";
      this.order.province = "";
      this.order.city = "";
      this.order.area = "";
      this.order.startTime = "";
      this.order.endTime = "";
      this.order.nnOrderFlag = "0";
      this.response.deviceBusinessData = [];
      this.response.orderBusinessData = [];
      this.response.storeBusinessData = [];
      this.response.total = 0;
      switch(value.index) {
        case "0": {
          this.requestDeviceBusinessData();
          break;
        }
        case "1": {
          this.requestOrderBusiessData();
          break;
        }
        case "2": {
          this.requestStoreBusinessData();
          break;
        }
      }

    },
    /**
     * 设备模块选择部署日期触发时间
     */
    chooseTime(events){
      switch (this.modelValue) {
        case "0": {
          this.device.startTime = events[0];
          this.device.endTime = events[1];
          break;
        }
        case "1": {
          this.order.startTime = events[0];
          this.order.endTime = events[1];
          break;
        }
      }
    },

    /**
     * 查询设备业务数据
     */
    requestDeviceBusinessData(){
      this.device.current = this.query.current;
      this.device.size = this.query.size;
      deviceBusinessData(this.device).then(result=>{
        this.response.deviceBusinessData = result.data.records;
        this.response.total = result.data.total;
      })
    },

    /**
     * 查询订单业务数据
     */
    requestOrderBusiessData(){
      this.order.current = this.query.current;
      this.order.size = this.query.size;
      orderBusinessData(this.order).then(result=>{
        this.response.orderBusinessData = result.data.records;
        this.response.total = result.data.total;
      })
    },

    /**
     * 查询门店订单业务数据
     */
    requestStoreBusinessData(){
      this.store.current = this.query.current;
      this.store.size = this.query.size;
      storeBusinessData(this.store).then(result=>{
        this.response.storeBusinessData = result.data.records;
        this.response.total = result.data.total;
      })
    },

    /**
     * 点击查询数据
     */
    queryData(){
      switch(this.modelValue) {
        case "0": {
          this.requestDeviceBusinessData();
          break;
        }
        case "1": {
          this.requestOrderBusiessData();
          break;
        }
        case "2": {
          this.requestStoreBusinessData();
          break;
        }
      }
    },

    /**
     * 重置
    */
   reSet(){
     switch(this.modelValue) {
        case "0": {
          this.device.deviceId = "";
          this.device.deviceType = "";
          this.device.onOffState = "";
          this.device.deployState = "";
          this.device.offLineTime = "";
          this.device.csName = "";
          this.device.csPhone = "";
          this.device.bdName = "";
          this.device.bdPhone = "";
          this.device.storeName = "";
          this.device.startTime = "";
          this.device.endTime = "";
          this.query.current = 1;
          this.requestDeviceBusinessData();
          break;
       }
        case "1": {
          this.order.orderId = "";
          this.order.csName = "";
          this.order.csPhone = "";
          this.order.bdName = "";
          this.order.bdPhone = "";
          this.order.storeName = "";
          this.order.bsName = "";
          this.order.bsPhone = "";
          this.order.usPhone = "";
          this.order.rentDuration = "";
          this.order.orderSource = "";
          this.order.powerBankId = "";
          this.order.powerBoxId = "";
          this.order.province = "";
          this.order.city = "";
          this.order.area = "";
          this.order.startTime = "";
          this.order.endTime = "";
          this.order.nnOrderFlag = "0";
          this.query.current = 1;
          this.requestOrderBusiessData();
          break;
        }
        case "2":{
          this.store.csName = "";
          this.store.csPhone = "";
          this.store.bsName = "";
          this.store.bsPhone = "";
          this.store.bdName = "";
          this.store.bdPhone = "";
          this.store.storeCode = "";
          this.store.storeName = "";
          this.store.concatPerson = "";
          this.store.concatPhone = "";
          this.store.province = "";
          this.store.city = "";
          this.store.area = "";
          this.query.current = 1;
          this.requestStoreBusinessData();
          break;
        }
     }
   },

   /**
    * 页码改变事件
    */
   currenChangeHandle(value){
     this.query.current = value;
     this.queryData();

   },

   openNotification(){
     this.$notify.success({
      title: '导出',
      dangerouslyUseHTMLString: true,
      message: this.message,
      type: this.type,
      position: 'bottom-right',
      duration: this.showTime
    });
   },

   /**
    * 导出数据
    */
   exportData() {
     this.openNotification();
     switch(this.modelValue) {
        case "0": {
          let params = {
            deviceId: this.device.deviceId,
            csName: this.device.csName,
            csPhone: this.device.csPhone,
            bdName: this.device.bdName,
            bdPhone: this.device.bdPhone,
            storeName: this.device.storeName,
            startTime: this.device.startTime,
            endTime: this.device.endTime,
          }
          exportDeviceBusinessData(params).then(result=>{
            this.$notify.closeAll();
            window.open(GLOBAL_URL.excelUpload+result.data);
          })
          break;
       }
        case "1": {
          let params = {
            orderId: this.order.orderId,
            csName: this.order.csName,
            csPhone: this.order.csPhone,
            bdName: this.order.bdName,
            bdPhone: this.order.bdPhone,
            storeName: this.order.storeName,
            bsName: this.order.bsName,
            bsPhone: this.order.bsPhone,
            usPhone: this.order.usPhone,
            rentDuration: this.order.rentDuration,
            orderSource: this.order.orderSource,
            powerBankId: this.order.powerBankId,
            powerBoxId: this.order.powerBoxId,
            province: this.order.province,
            city: this.order.city,
            area: this.order.area,
            startTime: this.order.startTime,
            endTime: this.order.endTime,
            nnOrderFlag: this.order.nnOrderFlag
          }
          exportOrderBusinessData(params).then(result=>{
            this.$notify.closeAll();
            window.open(GLOBAL_URL.excelUpload+result.data)
          })
          break;
        }
        case "2":{
          let params = {
            csName: this.store.csName,
            csPhone: this.store.csPhone,
            bsName: this.store.bsName,
            bsPhone: this.store.bsPhone,
            bdName: this.store.bdName,
            bdPhone: this.store.bdPhone,
            storeCode: this.store.storeCode,
            storeName: this.store.storeName,
            concatPerson: this.store.concatPerson,
            concatPhone: this.store.concatPhone,
            province: this.store.province,
            city: this.store.city,
            area: this.store.area,
          }
          exportStoreBusinessData(params).then(result=>{
            this.$notify.closeAll();
            window.open(GLOBAL_URL.excelUpload+result.data)
          })
          break;
        }
     }
   },

   /**
    * 省下拉框选择触发事件
    */
   provinceChoose(value){
     this.order.city = '';
     this.order.area = '';
     this.store.city = '';
     this.store.area = '';
     for (let item of this.province) {
      if (value == item.code) {
        this.city = item.childrenDictList
      }
    }
   },

   /**
    * 市下拉框选择触发事件
    */
   cityChoose(value){
     this.order.area = '';
     this.store.area = '';
     for (let item of this.city) {
        if (value == item.code) {
            this.area = item.childrenDictList;
        }
      }
   }

  },
  mounted() {
    this.province = JSON.parse(sessionStorage.getItem("dict")).area
    this.orderSource = JSON.parse(sessionStorage.getItem("global")).order_source
    this.global = JSON.parse(sessionStorage.getItem("global"))
    this.queryData();
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  },
}
</script>
<style scoped>
.businessData {
  width: 100%;
  height: 100%;
  }
  .el-form-item {
    display: inline-block !important;
  }
  .el-form .el-input{
    width: 180px;
  }
  .el-form {
    float: left;
  }
  .el-form-item__label {
    display: none;
    width: 0px !important;
  }
  .el-form-item__content {
    margin-left: 3px !important;
    margin-right: 3px !important;
  }
  .el-table{
    width: calc(100% - 20px);
    margin-top: 10%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/businessdata/businessdata.vue